import { Component,OnInit,OnDestroy,AfterViewInit,HostListener,ViewChild,ElementRef,ChangeDetectorRef } from '@angular/core';
import { takeWhile } from "rxjs/operators";
import { DecimalPipe } from "@angular/common";
import { addMonths, addYears, format, parse } from 'date-fns';
import addDays from 'date-fns/addDays';
import * as c3 from 'c3';
import * as d3 from "d3";
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import {
    PagingInfo
} from "src/app/shared/vo";
import {
    FilterSecToTime
    ,FilterDist
    ,FilterDateDiff
} from "src/app/shared/filter";
import {
    FvmsCommonService
    ,FvmsApiAuthService
    ,FvmsApiDtgDashboardService
    ,FvmsApiDtgDriveSafeEcoService
} from "src/app/shared/service";

@Component({
    templateUrl: './dtg.analytics.dashboard.component.html'
    ,providers: [FilterSecToTime,DecimalPipe,FilterDist,FilterDateDiff]
    ,styleUrls: ["./dtg.analytics.dashboard.component.scss"]
})
export class DtgAnalyticsDashboardComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    companyInfo:any;
    currentUserInfo:any;
    userGroupId:number;
    dtgTeamId:string = "";
    ymdCurr:string = "";
    ymdBefore1:string = "";
    ymdBefore2:string = "";
    carAllCnt:number = 0;
    carDriveCnt:number = 0;
    listCarUseCnt:any[] = [];

    listCarUseDistMax:any[] = [];
    listCarUseDistMin:any[] = [];
    listCarUseDurMax:any[] = [];
    listCarUseDurMin:any[] = [];

    chartColors:any[] = ['#4fc3f7', '#fb8c00', '#7460ee', '#f62d51', '#20c997', '#2962FF', '#40c4ff', '#2961ff', '#ff821c', '#7e74fb'];

    chart01:any;
    chart02:any;

    @ViewChild('pChart01') pChart01:ElementRef;
    @ViewChild('pChart02') pChart02:ElementRef;
    heightChart01:BehaviorSubject<any> = new BehaviorSubject(200);
    heightChart02:BehaviorSubject<any> = new BehaviorSubject(200);

    constructor(
        private fvmsCommonService:FvmsCommonService
        ,private fvmsApiDtgDashboardService:FvmsApiDtgDashboardService
        ,private filterSecToTime:FilterSecToTime
        ,private filterDist:FilterDist
        ,private filterDateDiff:FilterDateDiff
        ,private fvmsApiAuthService:FvmsApiAuthService
        ,private changeDetectorRef:ChangeDetectorRef
        ,private fvmsApiDtgDriveSafeEcoService:FvmsApiDtgDriveSafeEcoService
    ) {
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        this.userGroupId = parseInt(this.currentUserInfo.userGroupId);
        if(this.userGroupId > 100){
            this.dtgTeamId = this.currentUserInfo.teamId;
        }
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();

        this.fvmsCommonService.subscribeCompanyInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(companyInfo => {
                this.companyInfo = companyInfo;
                this.loadAll();
            });

        this.heightChart01
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(h => {
                if(this.chart01){
                    this.chart01.resize({height:h});
                }
            });
        this.heightChart02
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(h => {
                if(this.chart02){
                    this.chart02.resize({height:h});
                }
            });
    }

    ngOnInit() {
        // this.loadAll();
    }

    ngOnDestroy() {
        this.isContinue = false;
    }

    ngAfterViewInit() {
        this.changeDetectorRef.detectChanges();
    }

    loadAll(){
        this.carAllCnt = 0;
        this.listCarUseCnt = [];
        this.listCarUseDistMax = [];
        this.listCarUseDistMin = [];
        this.listCarUseDurMax = [];
        this.listCarUseDurMin = [];

        this.initChart01();
        this.initChart02();
        this.loadCarAllCnt();

        this.loadCarUseTop("dtgDistAccumul","desc")
            .then((listItem:any[]) => {
                this.listCarUseDistMax = listItem;
            });



        // this.loadCarUseTop("dtgDistAccumul","asc")
        //     .then((listItem:any[]) => {
        //         this.listCarUseDistMin = listItem;
        //     });



        this.loadCarUseTop("dtgRegDtDuration","desc")
            .then((listItem:any[]) => {
                this.listCarUseDurMax = listItem;
            });


        // this.loadCarUseTop("dtgRegDtDuration","asc")
        //     .then((listItem:any[]) => {
        //         this.listCarUseDurMin = listItem;
        //     });
    }

    // 현재 운행 차량
    loadCarAllCnt(){
        this.fvmsApiDtgDashboardService.getCarCountAll(this.companyInfo.companyId,this.dtgTeamId,null)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    if(apiResponse.resultValue){
                        this.carAllCnt = apiResponse.resultValue.dtgCarCnt;
                        this.carDriveCnt = apiResponse.resultValue.dtgDriveCarCnt;
                        // 차트 : 운행거리비교
                        // 차트 : 운행시간비교
                        this.loadCarUseCnt();
                    }
                }
            });
    }

    //전체 운행 거리
    //전체 운행 시간
    //전체 트립 건수
    //운행 차량 평균 운행 거리
    //운행 차량 평균 운행 시간
    //트립 평균 운행 거리
    //트립 평균 운행 시간
    // 차트 : 운행거리비교
    // 차트 : 운행시간비교
    loadCarUseCnt(){
        let today = addDays(new Date(),-1);
        let timeCurr = format(today,"yyyy-MM-dd 23:59:59");
        this.ymdCurr = format(today,"yyyy-MM-dd");

        let dayBefore1 = addDays(today,-1);
        this.ymdBefore1 = format(dayBefore1,"yyyy-MM-dd");

        let dayBefore2 = addDays(today,-2);
        let timeBefore2 = format(dayBefore2,"yyyy-MM-dd 00:00:00");
        this.ymdBefore2 = format(dayBefore2,"yyyy-MM-dd");

        let searchInfo = {
            companyId:this.companyInfo.companyId
            ,dtgTeamId:this.currentUserInfo?.teamId || ""
            ,searchDateFrom:timeBefore2
            ,searchDateTo:timeCurr
            ,dtgGroupByRegDtYy:"Y"//년도별 동시운행차량수
            ,dtgGroupByRegDtMm:"Y"//월별 동시운행차량수
            ,dtgGroupByRegDtDd:"Y"//일별 동시운행차량수
        };

        let pagingInfo2 = new PagingInfo();
        this.fvmsApiDtgDriveSafeEcoService.getListReportSafeDriving(searchInfo,pagingInfo2)  // 일별
        // this.fvmsApiDtgDashboardService.getCarUseCount(searchInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    if(apiResponse.resultValue){
                        // console.log("loadCarUseCnt",apiResponse.resultValue);
                        this.listCarUseCnt = apiResponse.resultValue;
                        for(let a=0;a<this.listCarUseCnt.length;a++){
                            let item = this.listCarUseCnt[a];
                            item.dtgDistAccumulK = item.dtgDistAccumul * 0.001;

                            if(item.dtgRegDt === this.ymdCurr){
                                item.name = "1일 전";
                            }

                            if(item.dtgRegDt === this.ymdBefore1){
                                item.name = "2일 전";
                            }

                            if(item.dtgRegDt === this.ymdBefore2){
                                item.name = "3일 전";
                            }
                        }

                        this.chart01.load({
                            json:this.listCarUseCnt
                            ,keys:{
                                x:"name"
                                ,value:[
                                    "dtgDistAccumulK"
                                ]
                            }
                        });

                        this.chart02.load({
                            json:this.listCarUseCnt
                            ,keys:{
                                x:"name"
                                ,value:[
                                    "dtgRegDtDuration"
                                ]
                            }
                        });
                    }
                }
            });
    }

    // 운행 거리 Max 3
    // 운행 시간 Max 3
    loadCarUseTop(orderField:string = "dtgDistAccumul",orderType:string = "asc"){
        let promise = new Promise((resolve,reject) => {
            let today = addDays(new Date(),-1);
            let dateFrom = format(today,"yyyy-MM-dd 00:00:00");
            let dateTo = format(today,"yyyy-MM-dd 23:59:59");

            let searchInfo = {
                companyId:this.companyInfo.companyId
                ,dtgTeamId:this.currentUserInfo?.teamId || ""
                ,searchDateFrom:dateFrom
                ,searchDateTo:dateTo
                ,dtgGroupByRegDtYy:"Y"//년도별 동시운행차량수
                ,dtgGroupByRegDtMm:"Y"//월별 동시운행차량수
                // ,dtgGroupByRegDtDd:"Y"//일별 동시운행차량수
                ,dtgGroupByUnitId:"Y"//단말별 동시운행차량수
            };

            let pagingInfo2 = new PagingInfo();
            pagingInfo2.pageSize = 100;
            this.fvmsApiDtgDriveSafeEcoService.getListReportSafeDriving(searchInfo,pagingInfo2)
            // this.fvmsApiDtgDashboardService.getCarUseTop(searchInfo)
                .pipe(takeWhile(() => this.isContinue))
                .subscribe(apiResponse => {
                    if(apiResponse.resultStatus === "ok"){
                        if(apiResponse.resultValue){
                            // console.log("loadCarUseTop",apiResponse.resultValue);
                            resolve(apiResponse.resultValue);
                        }
                    }else{
                        resolve(null);
                    }
                },err => {
                    console.error("loadCarUseTop",err);
                    resolve(null);
                });
        });
        return promise;
    }

    // 현재 운행 차량 수
    sumCnt(dispDay){
        let cnt = 0;
        if(this.listCarUseCnt){
            let foundItem = this.listCarUseCnt.find((item,idx) => {
                return item.dtgRegDt === dispDay;
            });
            // console.log("sumCnt",foundItem.dtgDriveCarCnt);
            if(foundItem){
                cnt = foundItem.dtgDriveCarCnt;
            }
        }
        return cnt;
    }

    // 현재 운행 차량 퍼센트
    percentCnt(dispDay){
        let pct = 0.0;
        if(this.carAllCnt){
            pct = (this.carDriveCnt / this.carAllCnt) * 100;
        }
        return pct;
    }

    // 전체 운행 거리
    sumDist(dispDay){
        let cnt = 0.0;
        if(this.listCarUseCnt){
            let foundItem = this.listCarUseCnt.find((item,idx) => {
                return item.dtgRegDt === dispDay;
            });
            if(foundItem){
                cnt = foundItem.dtgDistAccumul * 0.001;
            }
        }
        return cnt;
    }

    // 전체 운행 거리 퍼센트
    percentDist(dispDay1,dispDay2){
        let pct = 0.0;
        let sum1 = this.sumDist(dispDay1);
        let sum2 = this.sumDist(dispDay2);
        if(sum2){
            pct = ((sum1 - sum2) / sum2) * 100;
        }
        return pct;
    }

    // 전체 운행 시간
    sumDuration(dispDay){
        let cnt = 0.0;
        if(this.listCarUseCnt){
            let foundItem = this.listCarUseCnt.find((item,idx) => {
                return item.dtgRegDt === dispDay;
            });
            if(foundItem){
                cnt = foundItem.dtgRegDtDuration;
            }
        }
        return cnt;
    }

    // 전체 운행 시간 퍼센트
    percentDuration(dispDay1,dispDay2){
        let pct = 0.0;
        let sum1 = this.sumDuration(dispDay1);
        let sum2 = this.sumDuration(dispDay2);
        if(sum2){
            pct = ((sum1 - sum2) / sum2) * 100;
        }
        return pct;
    }

    // 전체 트립 건수
    sumTrip(dispDay){
        let cnt = 0.0;
        if(this.listCarUseCnt){
            let foundItem = this.listCarUseCnt.find((item,idx) => {
                return item.dtgRegDt === dispDay;
            });
            if(foundItem){
                cnt = foundItem.dtgDriveTripCnt;
            }
        }
        return cnt;
    }

    // 전체 트립 건수 퍼센트
    percentTrip(dispDay1,dispDay2){
        let pct = 0.0;
        let sum1 = this.sumTrip(dispDay1);
        let sum2 = this.sumTrip(dispDay2);
        if(sum2){
            pct = ((sum1 - sum2) / sum2) * 100;
        }
        return pct;
    }

    // 운행 차량 평균 운행 거리
    avgDist(dispDay){
        let cnt = 0.0;
        if(this.listCarUseCnt){
            let foundItem = this.listCarUseCnt.find((item,idx) => {
                return item.dtgRegDt === dispDay;
            });
            if(foundItem){
                cnt = (foundItem.dtgDistAccumul * 0.001) / foundItem.dtgDriveCarCnt;
            }
        }
        return cnt;
    }

    // 운행 차량 평균 운행 거리 퍼센트
    percentAvgDist(dispDay1,dispDay2){
        let pct = 0.0;
        let sum1 = this.avgDist(dispDay1);
        let sum2 = this.avgDist(dispDay2);
        if(sum2){
            pct = ((sum1 - sum2) / sum2) * 100;
        }
        return pct;
    }

    // 운행 차량 평균 운행 시간
    avgDuration(dispDay){
        let cnt = 0.0;
        if(this.listCarUseCnt){
            let foundItem = this.listCarUseCnt.find((item,idx) => {
                return item.dtgRegDt === dispDay;
            });
            if(foundItem){
                cnt = Math.floor(foundItem.dtgRegDtDuration / foundItem.dtgDriveCarCnt);
            }
        }
        return cnt;
    }

    // 운행 차량 평균 운행 시간 퍼센트
    percentAvgDuration(dispDay1,dispDay2){
        let pct = 0.0;
        let sum1 = this.avgDuration(dispDay1);
        let sum2 = this.avgDuration(dispDay2);
        if(sum2){
            pct = ((sum1 - sum2) / sum2) * 100;
        }
        return pct;
    }

    // 트립 평균 운행 거리
    avgTripDist(dispDay){
        let cnt = 0.0;
        if(this.listCarUseCnt){
            let foundItem = this.listCarUseCnt.find((item,idx) => {
                return item.dtgRegDt === dispDay;
            });
            if(foundItem){
                cnt = (foundItem.dtgDistAccumul * 0.001) / foundItem.dtgDriveTripCnt;
            }
        }
        return cnt;
    }

    // 트립 평균 운행 거리 퍼센트
    percentAvgTripDist(dispDay1,dispDay2){
        let pct = 0.0;
        let sum1 = this.avgTripDist(dispDay1);
        let sum2 = this.avgTripDist(dispDay2);
        if(sum2){
            pct = ((sum1 - sum2) / sum2) * 100;
        }
        return pct;
    }

    // 트립 평균 운행 시간
    avgTripDuration(dispDay){
        let cnt = 0.0;
        if(this.listCarUseCnt){
            let foundItem = this.listCarUseCnt.find((item,idx) => {
                return item.dtgRegDt === dispDay;
            });
            if(foundItem){
                cnt = Math.floor(foundItem.dtgRegDtDuration / foundItem.dtgDriveTripCnt);
            }
        }
        return cnt;
    }

    // 트립 평균 운행 시간 퍼센트
    percentAvgTripDuration(dispDay1,dispDay2){
        let pct = 0.0;
        let sum1 = this.avgTripDuration(dispDay1);
        let sum2 = this.avgTripDuration(dispDay2);
        if(sum2){
            pct = ((sum1 - sum2) / sum2) * 100;
        }
        return pct;
    }

    initChart01(){
        let self = this;
        this.chart01 = c3.generate({
            bindto: '#chart01'
            ,data: {
                // columns: [
                //     ['오늘',0]
                //     ,['1일 전',0]
                //     ,['2일 전',0]
                // ]
                json:this.listCarUseCnt
                ,keys:{
                    x:"name"
                    ,value:[
                        "dtgDistAccumulK"
                    ]
                }
                ,type: 'bar'
                ,color:(color,d) => {
                    // console.log("color",d);
                    return self.chartColors[d["index"] % self.chartColors.length];
                    // return color;
                }
                ,onclick:(d,el) => {
                    console.log("click",d.id,d.value);
                }
                ,onmouseover:(d) => {
                }
            }
            ,axis:{
                x:{
                    type:"category"
                }
            }
            ,bar: {

            }
            ,tooltip:{
                format:{
                    name:function(name, ratio, id, idx){
                        // console.log("tooltip",name, ratio, id, idx);
                        return self.listCarUseCnt[idx].name;
                    }
                }
            }
            ,legend: {
                hide: true
            }
            ,color: {
                pattern: self.chartColors
            }
        });
        // this.chart01Data = [
        //     {
        //         regDt:"2020-09-03"
        //         ,dtgAccumulDist:123
        //         ,name:"오늘"
        //     }
        //     ,{
        //         regDt:"2020-09-02"
        //         ,dtgAccumulDist:132
        //         ,name:"1일 전"
        //     }
        //     ,{
        //         regDt:"2020-09-01"
        //         ,dtgAccumulDist:130
        //         ,name:"2일 전"
        //     }
        // ];
        // this.chart01.load({
        //     json:this.chart01Data
        //     ,keys:{
        //         x:"regDt"
        //         ,value:[
        //             "dtgAccumulDist"
        //         ]
        //     }
        // });
        // this.chart01.load({
        //     columns:[
        //         ['오늘',123]
        //         ,['1일 전',134]
        //         ,['2일 전',143]
        //     ]
        // });
    }

    initChart02(){
        let self = this;
        this.chart02 = c3.generate({
            bindto: '#chart02'
            ,data: {
                json:this.listCarUseCnt
                ,keys:{
                    x:"regDt"
                    ,value:[
                        "dtgRegDtDuration"
                    ]
                }
                ,type: 'bar'
                ,color:(color,d) => {
                    // console.log("color",d);
                    return self.chartColors[d["index"] % self.chartColors.length];
                    // return color;
                }
                ,onclick:(d,el) => {
                    console.log("click",d.id,d.value);
                }
                ,onmouseover:(d) => {
                }
            }
            ,axis:{
                x:{
                    type:"category"
                }
                ,y:{
                    tick: {
                        format: function(y){
                            return self.filterSecToTime.transform(y,"HH:mm:ss");
                        }
                    }
                }
            }
            ,bar: {

            }
            ,tooltip:{
                format:{
                    name:function(name, ratio, id, idx){
                        // console.log("tooltip",name, ratio, id, idx);
                        return self.listCarUseCnt[idx].name;
                    }
                }
            }
            ,legend: {
                hide: true
            }
            ,color: {
                pattern: self.chartColors
            }
        });
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        // this.changeDetectorRef.detectChanges();
        this.getPChart01Height();
        this.getPChart02Height();
        this.changeDetectorRef.detectChanges();
    }

    getPChart01Height(){
        let h = 200;
        if(this.pChart01 && this.pChart01.nativeElement){
            h = this.pChart01.nativeElement.offsetHeight * 0.96;
        }
        this.heightChart01.next(h);
    }

    getPChart02Height(){
        let h = 200;
        if(this.pChart02 && this.pChart02.nativeElement){
            h = this.pChart02.nativeElement.offsetHeight * 0.96;
        }
        this.heightChart02.next(h);
    }
}
